import { down } from "styled-breakpoints";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-content: center;
  flex-direction: column;
  width: 100%;
  padding: 25px;
  background: #fff;
  box-shadow: 2px 2px 5px 1px rgb(0 0 0 / 0.05);
  margin: auto;

  .report-list {
    width: 50%;
  }



  ${down("sm")} {
    .report-list {
      width: 100%;
    }
  }
`
